import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fromJS } from 'immutable';

import SettingsModal from 'src/component/UI/SettingsModal/SettingsModal';
import { SettingsModalTypes } from 'src/component/UI/SettingsModal/SettingsModalTypes';

import { setSettingsModalClose } from 'src/module/device/action';
import { getSettingsModal } from 'src/module/device/selector';
import { createFacility } from 'src/module/admin/action';
import { isWhitelabel } from 'src/utils/utils';
import { Map } from 'immutable';
import { useTranslation } from 'src/i18n';

function AddFacilityModal () {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const whitelabel = isWhitelabel();
  const settingsModal = useSelector(getSettingsModal(null), (prev, next) => prev.equals(next));
  const [filledValuesObj, setFilledValuesObj] = useState({});

  // Static fields definition
  const fields = useMemo(() => {
    return {
      facility_name: {
        type: 'text',
        label: t('clientProperties.facilityName'),
        errorText: t('common.required'),
        required: true,
        order: 10,
      },
      vanity_url: {
        type: 'vanityUrl',
        label: t('admin.vanityUrl'),
        schema: Map({
          matches: Map({
            value: /^https:\/\/(?!(prod|staging)\.smarttrace\.ai$)([a-zA-Z0-9-]+)\.(smarttrace\.ai|atcom\.plus)(\/.*)?$/,
            message: whitelabel ? t('admin.vanityUrlFormatWhitelabel') : t('admin.vanityUrlFormat')
          })
        }),
        errorText: t('admin.vanityUrlInvalid'),
        required: true,
        order: 20,
      }
    };
  }, [t, whitelabel]);

  const handleChange = useCallback((name, value) => {
    setFilledValuesObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleSubmit = useCallback(
    (rec) => {

      dispatch(createFacility(rec.get('facility_name'), rec.get('vanity_url')));
    },
    [dispatch]
  );

  const handleClose = useCallback(() => {
    setFilledValuesObj({});
    dispatch(setSettingsModalClose(null));
  }, [dispatch]);

  useEffect(() => {
    if (!settingsModal?.get('isOpen')) {
      setFilledValuesObj({});
    }
  }, [settingsModal]);

  return (
    <SettingsModal
      open={
        settingsModal?.get('isOpen') &&
        settingsModal?.get('id') === SettingsModalTypes.ADD_FACILITY
      }
      handleClose={handleClose}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
      title={t('admin.addFacility')}
      loading={settingsModal?.get('loading')}
      settings={fromJS(filledValuesObj)}
      fields={fromJS(fields)}
    />
  );
}

export default React.memo(AddFacilityModal);
